const OnTabSelectPort = {
  add: function(app) {
    app.ports.tabSelected.subscribe(tabId => {
      app.ports.onTabSelected.send(tabId);
    });
  }
}

module.exports = OnTabSelectPort;
